import React, { useContext } from 'react';
import { Modal, Button } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import { useRecoilState } from '../../hooks';
import ParentContext from '@/pages/BatchCarts/context'

import styles from '@/pages/CartsNew/index.module.scss';

const Operate = () => {
  const { t } = useTranslation();
  const [current, setCurrent] = useRecoilState('current');
  const { updateAfterDelete } = useContext(ParentContext);

  const handleOk = () => {
    console.log(current, 'updateAfterDelete')
    updateAfterDelete()
  }

  const handleCancel = () => {
    setCurrent(undefined);
  };

  return (
    <Modal
      title={
        <div className={styles.deleteModal}>
          <InfoCircleOutlined style={{ color: 'orange' }} />
          <span style={{ marginLeft: '12px' }}>
            {current?.list?.length > 1
              ? TLT(`确认将如下{T}个商品移出采购清单吗？`).replace('{T}', current?.list?.length)
              : TLT(`确认将如下商品移出采购清单吗？`)}
          </span>
        </div>
      }
      onCancel={handleCancel}
      open={current && current?.list?.length > 0}
      footer={
        <div>
          <Button
            type="primary"
            key="ok"
            style={{ fontSize: '14px', minWidth: '60px', height: '32px' }}
            onClick={() => {
              handleOk && handleOk();
            }}
          >
            {TLT(`确认`)}
          </Button>
          <Button
            key="cancel"
            onClick={() => {
              handleCancel && handleCancel();
            }}
            style={{ fontSize: '14px', minWidth: '60px', height: '32px', marginRight: '10px' }}
          >
            {TLT(`取消`)}
          </Button>
        </div>
      }
    >
      <div className={`${styles.modalDelete}`}>
        {current?.list?.map((item, index) => {
          return (
            <div className={styles.product} key={index}>
              <img src={item.skuImg} alt={item.skuName} />
              <div className={styles.detail}>
                <div className={styles.title}>{item.skuName}</div>
                <div className={styles.code}>{TLT(`商品编码：`)}{item.sku}</div>
                <div className={styles.unit}>
                  {TLT(`单位：`)}
                  {item?.unit || '-'}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </Modal>
  );
};

export default Operate;
